export default {
  "content": "<path d=\"M111.372.494H3.6a3 3 0 000 6h107.772a3 3 0 100-6z\" fill=\"#E9E9EB\"/>",
  "attrs": {
    "width": "115",
    "height": "7",
    "viewBox": "0 0 115 7",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};